import { showToast, showAlert } from "../../utils/helpers/ShowToast";
import authorizedAxios from "../../helpers/authorizedAxios";

export const SET_STOCK_TRANSFERS = "SET_STOCK_TRANSFERS";
export const SET_STOCK_TRANSFERS_LOADING = "SET_STOCK_TRANSFERS_LOADING";
export const SET_STOCK_TRANSFER_ACTION_LOADING = "SET_STOCK_TRANSFER_ACTION_LOADING";
export const SET_STOCK_TRANSFERS_ERROR = "SET_STOCK_TRANSFERS_ERROR";

const setError = (dispatch, error) => {
  dispatch({
    type: SET_STOCK_TRANSFERS_ERROR,
    error: error?.response?.data?.message || error?.message || "Terjadi kesalahan pada transfer stok.",
  });
};

const responseCollection = (response) => response?.data?.data?.data || response?.data?.data || [];

export const fetchStockTransfers = ({ limit = 100, page = 1, search = "", status = "" } = {}) => async (dispatch) => {
  dispatch({ type: SET_STOCK_TRANSFERS_LOADING, status: true });

  try {
    const response = await authorizedAxios.get("/stock-transfers", {
      params: { limit, page, search, status: status || undefined },
    });
    const data = response?.data?.data || {};
    dispatch({ type: SET_STOCK_TRANSFERS, data });

    return data;
  } catch (error) {
    setError(dispatch, error);
    return null;
  } finally {
    dispatch({ type: SET_STOCK_TRANSFERS_LOADING, status: false });
  }
};

export const getStockTransferById = (id) => async (dispatch) => {
  try {
    const response = await authorizedAxios.get(`/stock-transfers/${id}`);
    return response?.data?.data || null;
  } catch (error) {
    setError(dispatch, error);
    showAlert({
      type: "error",
      message: error?.response?.data?.message || "Detail transfer stok gagal dimuat.",
    });
    return null;
  }
};

export const fetchStockTransferOptions = (activeOutletId) => async (dispatch) => {
  try {
    const [outletResponse, productResponse, materialResponse, unitResponse] = await Promise.all([
      authorizedAxios.get("/outlets"),
      authorizedAxios.get("/products", { params: { limit: 500, page: 1 } }),
      authorizedAxios.get("/materials/conversion-options"),
      authorizedAxios.get("/units", { params: { limit: 500, page: 1 } }).catch(() => null),
    ]);

    const units = responseCollection(unitResponse);
    const unitLabels = new Map(
      units.map((unit) => [String(unit.value || "").toLowerCase(), unit.label || unit.value]),
    );
    const labelFor = (unit) => unitLabels.get(String(unit || "").toLowerCase()) || unit || "pcs";

    return {
      outlets: (outletResponse?.data?.data?.outlets || []).filter(
        (outlet) => Number(outlet.id) !== Number(activeOutletId) && outlet.is_active,
      ),
      products: responseCollection(productResponse).map((product) => ({
        ...product,
        stock: Number(product.stock || 0),
        stock_unit: product.unit || "pcs",
        stock_unit_label: labelFor(product.unit || "pcs"),
      })),
      materials: responseCollection(materialResponse).filter((material) => !material.is_virtual_formula).map((material) => {
        const baseUnit = material.base_unit || material.unit || "pcs";
        return {
          ...material,
          stock: Number(material.stock || 0),
          stock_unit: baseUnit,
          stock_unit_label: labelFor(baseUnit),
        };
      }),
    };
  } catch (error) {
    setError(dispatch, error);
    showAlert({
      type: "error",
      message: error?.response?.data?.message || "Data item dan outlet gagal dimuat.",
    });
    return null;
  }
};

export const addStockTransfer = (data) => async (dispatch) => {
  dispatch({ type: SET_STOCK_TRANSFER_ACTION_LOADING, status: true });

  try {
    const response = await showToast(authorizedAxios.post("/stock-transfers", data), {
      loading: "Menyimpan draft transfer...",
      success: "Draft transfer berhasil dibuat!",
      error: (error) => error?.response?.data?.message || "Transfer gagal dibuat!",
    });
    showAlert({
      type: "success",
      message: response?.data?.message || "Draft transfer stok berhasil dibuat.",
    });
    return response?.data?.data || true;
  } catch (error) {
    setError(dispatch, error);
    return null;
  } finally {
    dispatch({ type: SET_STOCK_TRANSFER_ACTION_LOADING, status: false });
  }
};

const transitionStockTransfer = (id, action, messages) => async (dispatch) => {
  dispatch({ type: SET_STOCK_TRANSFER_ACTION_LOADING, status: true });

  try {
    const response = await showToast(authorizedAxios.post(`/stock-transfers/${id}/${action}`), {
      loading: messages.loading,
      success: messages.success,
      error: (error) => error?.response?.data?.message || messages.error,
    });
    showAlert({
      type: "success",
      message: response?.data?.message || messages.success,
    });
    return response?.data?.data || true;
  } catch (error) {
    setError(dispatch, error);
    return null;
  } finally {
    dispatch({ type: SET_STOCK_TRANSFER_ACTION_LOADING, status: false });
  }
};

export const shipStockTransfer = (id) => transitionStockTransfer(id, "ship", {
  loading: "Mengirim stok ke outlet tujuan...",
  success: "Stok berhasil dikirim!",
  error: "Stok gagal dikirim!",
});

export const receiveStockTransfer = (id) => transitionStockTransfer(id, "receive", {
  loading: "Menerima stok transfer...",
  success: "Stok transfer berhasil diterima!",
  error: "Stok transfer gagal diterima!",
});

export const cancelStockTransfer = (id) => transitionStockTransfer(id, "cancel", {
  loading: "Membatalkan transfer stok...",
  success: "Transfer stok berhasil dibatalkan!",
  error: "Transfer stok gagal dibatalkan!",
});
